import { updateInitialConfig, updateModifiedConfig } from "../../checksumStore";

export const updateRecordsviewChecksum = (recordsviewData, isInit = false) => {
  let storeConfig = { ...recordsviewData };
  if (isInit) {
    updateInitialConfig(storeConfig);
  } else {
    updateModifiedConfig(storeConfig);
  }

  return storeConfig;
};
